import { Alert, Button, Card, Group, Table } from '@mantine/core';
import { IconExternalLink, IconInfoCircle, IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import ConfirmationModal from '../Modals/ConfirmationModal';
import Spinner from '../Spinner';
import LoyaltyCouponModal from './LoyaltyCouponModal';

const LoyaltyCouponsTab = () => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();

  const [loyaltyCoupon, setLoyaltyCoupon] = useState();
  const [loyaltyCoupons, setLoyaltyCoupons] = useState();
  const [coupons, setCoupons] = useState();
  const [laodError, setLoadError] = useState();
  const [userError, setUserError] = useState();
  const [showDeleteId, setShowDeleteId] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/loyalty/coupons`)
      .then(({ loyaltyCoupons }) => {
        setLoyaltyCoupons(loyaltyCoupons);
      })
      .catch(setLoadError);
  }, [accountId, domainId, fetch]);

  useEffect(() => {
    if (!loyaltyCoupons) {
      return;
    }

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/coupons`)
      .then(({ coupons }) => {
        setCoupons(coupons.filter((c) => !loyaltyCoupons.map((c) => c.couponId).includes(c.id)));
      })
      .catch(setLoadError);
  }, [accountId, domainId, fetch, loyaltyCoupons]);

  if (laodError) {
    return <ErrorMessage message={laodError.message} />;
  }

  if (!loyaltyCoupons || !coupons) {
    return <Spinner />;
  }

  const del = (cb) => {
    setUserError(undefined);

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/loyalty/coupons/${showDeleteId}`, {
      method: 'DELETE',
    })
      .then(() => {
        setLoyaltyCoupons(loyaltyCoupons.filter((c) => c.id !== showDeleteId));
        cb();
      })
      .catch(setUserError);
  };

  return (
    <>
      <ConfirmationModal
        show={!!showDeleteId}
        close={() => setShowDeleteId(undefined)}
        confirm={del}
        message="This action cannot be undone!"
      />
      <Card withBorder>
        <Card.Section inheritPadding py="md">
          {coupons.length === 0 && (
            <Alert color="blue" icon={<IconInfoCircle size={16} />}>
              All dynamic coupon lists are currently assigned. To add new rules, please{' '}
              <a href={`/#/accounts/${accountId}/domains/${domainId}/coupons/new`}>
                add a new list of coupons <IconExternalLink size={14} />
              </a>{' '}
              first.
            </Alert>
          )}

          {loyaltyCoupons.length > 0 && (
            <Table striped withTableBorder highlightOnHover>
              <Table.Thead>
                <Table.Tr>
                  <Table.Th>Coupon</Table.Th>
                  <Table.Th>Title</Table.Th>
                  <Table.Th>Description</Table.Th>
                  <Table.Th>Point cost</Table.Th>
                  <Table.Th></Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {loyaltyCoupons.map((coupon, index) => (
                  <Table.Tr key={index}>
                    <Table.Td>{coupon.coupon.name}</Table.Td>
                    <Table.Td>{coupon.title}</Table.Td>
                    <Table.Td>{coupon.description}</Table.Td>
                    <Table.Td>{coupon.pointCost.toLocaleString('en-US')}</Table.Td>
                    <Table.Td>
                      <Group gap="sm" justify="flex-end">
                        <Button variant="default" size="sm" mr="md" onClick={() => setLoyaltyCoupon(coupon)}>
                          <IconPencil size={14} />
                        </Button>
                        <Button color="red" size="sm" onClick={() => setShowDeleteId(coupon.id)}>
                          <IconTrash size={14} />
                        </Button>
                      </Group>
                    </Table.Td>
                  </Table.Tr>
                ))}
              </Table.Tbody>
            </Table>
          )}

          <Button fullWidth disabled={coupons.length === 0} onClick={() => setLoyaltyCoupon({ pointCost: 100 })}>
            <IconPlus size={16} /> Add Rule
          </Button>
        </Card.Section>
      </Card>

      {userError && <ErrorMessage message={userError.message} />}

      <LoyaltyCouponModal
        loyaltyCoupon={loyaltyCoupon}
        onClose={() => setLoyaltyCoupon(undefined)}
        onSave={(loyaltyCoupon) => {
          let matched = false;
          const newLoyaltyCoupons = [];
          for (const coupon of loyaltyCoupons) {
            if (coupon.id === loyaltyCoupon.id) {
              newLoyaltyCoupons.push(loyaltyCoupon);
              matched = true;
            } else {
              newLoyaltyCoupons.push(coupon);
            }
          }

          if (!matched) {
            newLoyaltyCoupons.push(loyaltyCoupon);
          }
          setLoyaltyCoupons(newLoyaltyCoupons);
        }}
      />
    </>
  );
};

export default LoyaltyCouponsTab;
